import { useState } from 'react'
import { GitBranch, Columns3, FileText, Activity } from 'lucide-react'
import { FlowchartView } from './components/FlowchartView'
import { SwimLaneView } from './components/SwimLaneView'
import { WrittenView } from './components/WrittenView'
import { ScopeKpiView } from './components/ScopeKpiView'

type ViewMode = 'flowchart' | 'swimlane' | 'written' | 'scope-kpi'

const views: { id: ViewMode; label: string; icon: typeof GitBranch }[] = [
  { id: 'flowchart', label: 'Flowchart', icon: GitBranch },
  { id: 'swimlane', label: 'Swim Lanes', icon: Columns3 },
  { id: 'scope-kpi', label: 'Scope & KPIs', icon: Activity },
  { id: 'written', label: 'Written', icon: FileText },
]

export function ProcessFlowTool() {
  const [view, setView] = useState<ViewMode>('flowchart')

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold text-[var(--text-primary)]">Process Flow</h2>
          <p className="text-sm text-[var(--text-muted)] mt-1">
            How Presales and Implementations work — from deal trigger to go-live
          </p>
        </div>

        {/* View switcher */}
        <div className="flex items-center gap-1 p-1 rounded-lg bg-[var(--bg-secondary)] border border-[var(--border-color)]">
          {views.map((v) => {
            const Icon = v.icon
            const active = view === v.id
            return (
              <button
                key={v.id}
                onClick={() => setView(v.id)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all ${
                  active
                    ? 'bg-[var(--accent-color)] text-white'
                    : 'text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-tertiary)]'
                }`}
              >
                <Icon size={13} />
                {v.label}
              </button>
            )
          })}
        </div>
      </div>

      {/* View content */}
      {view === 'flowchart' && <FlowchartView />}
      {view === 'swimlane' && <SwimLaneView />}
      {view === 'scope-kpi' && <ScopeKpiView />}
      {view === 'written' && <WrittenView />}
    </div>
  )
}
